<template>
    <a-modal
        centered
        :visible="visible"
        :keyboard="false"
        :maskClosable="false"
        title="客户充值申请"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="recharge-create" :rules="rules">
            <a-form-model-item label="客户编号" prop="member_id" v-if="!(record && record.member_id)">
                <a-input v-model="form.member_id"></a-input>
            </a-form-model-item>
            <a-form-model-item label="充值金额" prop="amount">
                <a-input v-model="form.amount"></a-input>
            </a-form-model-item>

            <a-form-model-item label="客户充值时间" prop="paid_at" extra="准备填写客户的实际充值时间，以便财务审核">
                <a-date-picker show-time v-model="form.paid_at" style="width:100%" valueFormat="YYYY-MM-DD HH:mm" />
            </a-form-model-item>

            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
            <a-form-model-item label="付款凭证" prop="screenshot" extra="选择客户付款截图">
                <a-upload
                    list-type="picture-card"
                    name="file"
                    :action="action"
                    :withCredentials="true"
                    :show-upload-list="false"
                    @change="(info) => on_upload_change(info, 'screenshot')"
                    :headers="{ 'x-identity': 'manager' }"
                    accept="image/png, image/jpeg"
                >
                    <img v-if="form.screenshot" :src="form.screenshot" style="width:100%" />

                    <div v-else>
                        <a-icon :type="uploading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">
                            上传
                        </div>
                    </div>
                </a-upload>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        member_id: null,
        amount: null,
        remark: null,
        screenshot: null,
    };
    import env from "../../../../env";
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            mode: {
                default: "create",
            },
        },
        data() {
            return {
                action: env.base_url + "service/upload",
                submitting: false,
                uploading: false,
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    screenshot: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    paid_at: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    this.form.member_id = this.record.member_id;
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["recharge-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/apply/recharge", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                this.$refs["recharge-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_upload_change(info, field) {
                if (info.file.status === "uploading") {
                    this.uploading = true;
                    return;
                }
                if (info.file.status === "done") {
                    this.uploading = false;
                    if (info.file.response.success) {
                        this.form[field] = info.file.response.data.url;
                    } else {
                        this.$error({
                            title: "失败",
                            content: info.file.response.message,
                        });
                    }
                } else if (info.file.status === "error") {
                    this.$message.error(`${info.file.name} 上传失败.`);
                }
            },
        },
    };
</script>
